import {NgModule} from '@angular/core';
import {LanguageService} from './language.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
@NgModule({
    providers: [LanguageService]
})
export class LanguageModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/language/language.module.ts